import React, { FunctionComponent, ReactNode } from 'react'

import { useField } from 'formik'
import { SpaceProps, WidthProps } from 'styled-system'

import { Checkbox } from '@/atoms/input'

import FieldWrapper from './field-wrapper'

export interface CheckboxProps {
  label?: string
  checkboxLabel?: string
  fieldProps?: SpaceProps & WidthProps
  name?: string
  disabled?: boolean
  onChange?: (value: boolean) => void
  tooltip?: string
  checkboxFlag?: ReactNode
}

const CheckboxField: FunctionComponent<CheckboxProps> = ({
  label,
  checkboxLabel,
  fieldProps,
  name,
  disabled,
  onChange,
  tooltip,
  checkboxFlag,
}: CheckboxProps) => {
  const [field, meta, helpers] = useField(name)
  const hasError: boolean = meta.touched && !!meta.error
  const handleClick = (): void => {
    onChange && onChange(!field.value)
    helpers.setValue && helpers.setValue(!field.value)
  }

  return (
    <FieldWrapper id={field.name} meta={meta} label={label} fieldProps={fieldProps}>
      <Checkbox
        hasError={hasError}
        name={field.name}
        value={field.value}
        selected={!!field.value}
        onClick={handleClick}
        label={checkboxLabel}
        disabled={disabled}
        tooltip={tooltip}
        checkboxFlag={checkboxFlag}
      />
    </FieldWrapper>
  )
}

CheckboxField.displayName = 'CheckboxField'

export default CheckboxField
